



























































import {useGetters} from "vuex-composition-helpers"
import {IActivity} from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel"
import {defineComponent, PropType} from "@vue/composition-api"
import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue"
import DateAtom from "@/shared/components/atoms/card/DateAtom.vue"
import TitleAtom from "@/shared/components/atoms/card/TitleAtom.vue"
import TextAtom from "@/shared/components/atoms/card/TextAtom.vue"

export default defineComponent({
    name: "AvailableActivity",
    components: {TitleAtom, TextAtom, ButtonLinkAtom, DateAtom},
    props: {
        activity: {
            type: Object as PropType<IActivity>,
            required: true
        },
        interactive: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup: () => {
        const {getConfig} = useGetters(['getConfig'])

        return {
            getConfig
        }
    }
})
